import { Link } from "react-router-dom";
import EventCard from "@/components/feature/EventCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { sortByHeat } from "@/utils/content";

export default function FeaturedEvents() {
  const featured = sortByHeat().slice(0, 6);

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="精选事件"
            title="这几件事，来龙去脉都理好了"
            desc="每条都写明前因、经过、结果，并标注最近更新时间与当前状态，读完不容易断片。"
          />
          <Link
            to="/events"
            className="mb-8 flex w-fit items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700 md:mb-10"
          >
            查看全部事件
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((event, index) => (
            <EventCard key={event.id} event={event} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}